import { createTheme } from "@mui/material/styles"; 
import blue from "@mui/material/colors/blue";

const theme = createTheme({ palette: { primary: { main: blue[500], }, }, });

export default theme;
